

































import mixins from 'vue-typed-mixins';
import { ServiceProvider } from '../../utils/ProviderUtils';
import ProviderTypePicker from './ProviderTypePicker.vue';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => ServiceProvider,
    },
  },
  components: {
    ProviderTypePicker,
  },
});
